import { subscribe, useSnapshot } from "valtio";
import { configStore } from "../state/CommonState";
import TaskDatetime from "./task-datetime";
import Taskfileapproval, { validateFileApproval } from "./task-file-approval";
import Taskfiledisplay from "./task-file-display";
import Taskfiletable from "./task-file-table";
import { taskStore } from "./task-store";
import Taskapi from "./tasks-api";
import { useEffect, useState } from "react";
import { OneInput } from "./act-common";
import MonApi from "../state/mongo-api";

export default function MeasurementSlipaction(props) {
    useSnapshot(taskStore)
    useSnapshot(configStore)
    let task = taskStore.current
    let stage = task.stage

    if (stage >= 1) {
        return (
            <>
            {
                    (task.remarks) ?
                        <p>Remarks : {task.remarks}</p>
                        : <></>
                }
                <hr />
                <Taskfiledisplay validation={true} />
            </>
        )
    }
}
export function MeasurementSlipTrigger(props) {
    useSnapshot(taskStore)
    const [disableButton,setDisableButton] = useState(true)
    useEffect(()=>{
        let unsubscribe = subscribe(taskStore, () => {
            let disable = false
            taskStore.current.files.map((e) => {
                if (e.filename == '') {
                  disable = true
                }
            })
            setDisableButton(disable)
        })
        return unsubscribe
    },[taskStore])
    return (
        <>
            {/* <TaskDatetime /> */}
            <hr />
            <Taskfiletable />
            <hr />
            <OneInput label='Remarks' name='remarks' />
            
            <p>
                <span>
                    <button disabled={disableButton} style={{ float: 'left' }} className="button islink"
                        onClick={async (e) => {
                            taskStore.current.stage = 1
                            taskStore.current.pendingWith = process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE.toUpperCase()
                            taskStore.current.status = 'COMPLETED'
                            taskStore.setComplete()
                            taskStore.setCustomerComplete()
                            const entity = await MonApi.find('SHEntities',{_id:taskStore.current.entityId},{})
                            if(entity.length > 0 && entity[0]?.customer?.crossBorder?.salesVertical!='MSME'){
                               const files = taskStore.current.files.map((e)=>e.filename)
                               MonApi.updateOne('Bookings',{_id:taskStore.current.bookingNum},{measurementSlipList:[]})
                            }
                            setDisableButton(true)
                            await Taskapi.saveTask(taskStore.current)
                            taskStore.triggerActionVisible = false
                            taskStore.myActionVisible = false
                        }}>Trigger Action</button>
                </span>
            </p>
        </>
    )
}